import { PermissionModel } from './permission.model';
export class GrupoPermissionModel {
  id: number;
  name: string;
  permissions: PermissionModel[];
}



// WEBPACK FOOTER //
// /app/src/app/model/permission/grupopermission.model.ts